import React from 'react';
import { Grid, Label, Form, TextArea, Dropdown } from 'semantic-ui-react';
import InputField from 'common/InputField';
import ScriptEditor from './ScriptEditor';
import { targetTypesOptions, gainTypesOptions, schoolTypesOptions } from 'common/options';


const SpellEditor = function(props) {
  const spell = props.spell;
  const change = props.onChange;

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={16}>
        <Form>
          <Label>Description</Label>
          <TextArea value={spell.Description}
                    onChange={(e,d) => change('Description')(d.value)}
                    placeholder='Skill Description'/>
        </Form>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <Label>School</Label>
        <Dropdown selection
                  fluid
                  options={schoolTypesOptions}
                  value={spell.School}
                  onChange={(e,d) => change('School')(d.value)}
                  />
      </Grid.Column>
      <Grid.Column width={4}>
        <InputField value={spell.Level}
                    onChange={change('Level')}
                    label='Level'
                    placeholder='Level'
                    fluid
                    type='int' />
      </Grid.Column>
      <Grid.Column width={4}>
        <Label>Gain</Label>
        <Dropdown selection
                  fluid
                  options={gainTypesOptions}
                  value={spell.Gain}
                  onChange={(e,d) => change('Gain')(d.value)} />
      </Grid.Column>
      <Grid.Column width={4}>
        <InputField value={spell.Cost}
                    onChange={change('Cost')}
                    label='Cost'
                    placeholder='Cost'
                    fluid
                    type='int' />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <Label>Target type</Label>
        <Dropdown selection
                  fluid
                  options={targetTypesOptions}
                  value={spell.TargetType}
                  onChange={(e,d) => change('TargetType')(d.value)} />
      </Grid.Column>
      <Grid.Column width={12}>
        <Label>OnCast</Label>
        <ScriptEditor src={spell.OnCast}
                      onSave={change('OnCast')} />
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
  );
}



export default SpellEditor;
